'use strict';

function loadEventMap() {
	if (typeof google !== 'undefined') {
		var eventMap = new google.maps.Map(document.getElementById('map'), getDefaultMapRequest());
		var address = getEventAddress();
		var geocoder = new google.maps.Geocoder();
		updateMapFromGeocodeAddress(address, geocoder, eventMap);
	}
}

function updateMapFromGeocodeAddress(address, geocoder, eventMap) {
	var geocodeRequest = { address: address };
	geocoder.geocode(geocodeRequest, function(results, status) {
		if (status === 'OK') {
			eventMap.setCenter(results[0].geometry.location);
			var marker = new google.maps.Marker({
				map: eventMap,
				position: results[0].geometry.location
			});
			$('#map').removeClass('hidden');
		} else {
			console.log("Was not successful retrieving the latitude and longitude for the event address '" + address + "' for the following reason: '" + status + "'.");
		}
	});
}

function getDefaultMapRequest() {
	return {
		zoom: 15,
		center: {
			lat: 39.040748,
			lng: -84.614616
		}
	};
}

function getEventAddress() {
	var address = $('#map').data('address');
	if (address && address.length > 0) {
		return address;
	}

	return '5081 Olympic Blvd., Erlanger, KY 41018'; // DCI HQ
}

module.exports = {
	init: function() {
		$(document).ready(function() {
			loadEventMap();
		});
	}
};